import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BffUserService, LogoutComponent } from '@canvas/four-r-digital';

import { environment } from '../environments/environment';
import { LoginComponent } from './static/login/login.component';
import { InvalidPermissionsComponent } from './invalid-permissions/invalid-permissions.component';

const routes: Routes = [
  {
    path: 'main',
    loadChildren: () =>
      import('./modules/main/main.module').then((m) => m.MainModule),
    canMatch: [
      () => inject(BffUserService).matchesAnyClaim(environment.authClaims),
    ],
  },
  {
    path: 'main',
    component: InvalidPermissionsComponent,
    canMatch: [() => inject(BffUserService).isAuthenticated()],
  },
  {
    path: 'main',
    component: LoginComponent,
    canMatch: [() => inject(BffUserService).isNotAuthenticated()],
  },
  {
    path: 'forbidden',
    component: InvalidPermissionsComponent,
  },
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: 'main' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
